import React from 'react';

type CanvasToolbarProps = {
  zoomPercent: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onFit: () => void;
};

const CanvasToolbar: React.FC<CanvasToolbarProps> = ({
  zoomPercent,
  onZoomIn,
  onZoomOut,
  onFit,
}) => (
  <div className="die-line__toolbar" aria-label="Canvas controls">
    <button type="button" onClick={onFit} title="Fit dieline to screen">
      Fit
    </button>
    <span className="die-line__toolbar-divider" />
    <button type="button" onClick={onZoomOut} aria-label="Zoom out">
      −
    </button>
    <output>{zoomPercent}%</output>
    <button type="button" onClick={onZoomIn} aria-label="Zoom in">
      +
    </button>
  </div>
);

export default CanvasToolbar;
